__turbopack_context__.v({
  "card": "Advantages-module__Gp73DW__card",
  "cardContent": "Advantages-module__Gp73DW__cardContent",
  "main": "Advantages-module__Gp73DW__main",
});
